import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import React from 'react';
import PlanListFilter from './planListFilter';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

interface PlanListHeaderProps {
  showActionButtons: boolean;
  onCreatePlan: () => void;
  onCreatePurchase: () => void;
}

export const PlanListHeader: React.FC<PlanListHeaderProps> = ({
  showActionButtons,
  onCreatePlan,
  onCreatePurchase,
}) => {
  const { t } = useTranslation(['plans']);

  const { pathname } = useRouter();
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      mb={5}
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 2, sm: 0 },
      }}
    >
      <PlanListFilter />
      {showActionButtons && (
        <Box
          display="flex"
          gap="10px"
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Button
            variant="outlined"
            onClick={onCreatePlan}
            sx={{
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            <AddRoundedIcon />
            {t('plans:plan')}
          </Button>

          {pathname === '/cabinet/plans' && (
            <Button
              variant="outlined"
              onClick={onCreatePurchase}
              sx={{
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              <AddRoundedIcon />
              {t('plans:purchase')}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PlanListHeader;
